"use client";

import { Box, CircularProgress, Container, Typography } from "@mui/material";
import { CheckCircle, ErrorOutline } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { apiRemote } from "@/api";

export default function EmailVerified() {
  const [loading, setLoading] = useState(false);
  const [msg1, setMsg1] = useState("");
  const [msg2, setMsg2] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const { search } = useLocation();
  const email = new URLSearchParams(search).get("email");

  useEffect(() => {
    if (!email) return;
    setLoading(true);

    apiRemote
      .verifyEmail({
        email: email,
      })
      .then((data) => {
        if (data.code == 200) {
          setMsg1("Email Verified Successfully!");
          setMsg2(
            "Great news! Your email address has been successfully verified."
          );
          setIsSuccess(true);
        } else {
          setMsg1("Email Verification Failed");
          setMsg2(
            "We&apos;re sorry, but we couldn&apos;t verify your email address at this time."
          );
        }
        setLoading(false);
      });
  }, [email]);

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        flex: 1,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            textAlign: "center",
            gap: 2,
          }}
        >
          {loading ? (
            <Box
              sx={{
                p: 3,
                bgcolor: "white",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                {isSuccess ? (
                  <CheckCircle
                    sx={{
                      color: "success.main",
                      fontSize: "2rem",
                    }}
                  />
                ) : (
                  <ErrorOutline
                    sx={{
                      color: "error.main",
                      fontSize: "2rem",
                    }}
                  />
                )}

                <Typography
                  variant="h4"
                  component="h1"
                  sx={{
                    fontWeight: 500,
                    color: "text.primary",
                  }}
                >
                  {msg1}
                </Typography>
              </Box>

              <Typography
                variant="subtitle1"
                color="text.secondary"
                sx={{ mt: 1 }}
              >
                {msg2}
              </Typography>
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
}
